import User from '@/model/user'
import cookies from '@/utils/cookie'
import { device } from '@/utils/device'
import { getUser } from '@/plugins/cordova/index.js'
export default {
  namespaced: true,
  state: {
    user: new User({})
  },
  getters: {
    user(state) {
      return state.user
    },
    token(state) {
      return state.user.token || cookies.get('token') || window.MYAUTHORIZATION
    }
  },
  mutations: {
    setUser(state, user) {
      state.user = new User(user)
    }
  },
  actions: {
    setUser({ commit }) {
      return new Promise((resolve, reject) => {
        if (device.isRunningStandalone) {
          getUser(data => {
            commit('setUser', data)
            resolve(data)
          })
        } else {
          let user = cookies.get('USERINFO')
          if (user) {
            const data = JSON.parse(user)
            commit('setUser', data)
            resolve(user)
          } else {
            reject('加载用户失败')
          }
        }
      })
    }
  }
}
